import { FC, useContext, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { AuthContext } from "src/context/authContext";

const Footer: FC = (): JSX.Element => {
  const [isAccordianShown, setAccordianVisibility] = useState<boolean>(false);
  const location = useLocation();

  const { isUserAuthorized, isManufacturer, userData } = useContext(AuthContext);

  const changeAccordianVisibility = () => {
    setAccordianVisibility((isAccordianShown) => !isAccordianShown);
  };

  return (
    <footer className="sticky-bottom">
      <div className="container-fluid bg-primary">
        <div className="d-flex align-items-center justify-content-center flex-wrap text-uppercase footer-links">
          {location.pathname === "/enroll" ? (
          <span role="button" className="text-white nav-link p-2">
            Home
          </span>
          ): (
          <Link to={isUserAuthorized ? (userData && userData.is_password_changed ? (isManufacturer ? `/statistics` : `/cases`) : `/users/${userData?.id}/edit`) : `/users/sign_in`}
            className="text-white nav-link p-2">
              Home
          </Link>

          )}
          <span className="text-white">|</span>
          <a target="_blank" href="https://www.averitaspharma.com/privacy-statement/"
            rel="noreferrer"
            className="text-white nav-link p-2"
          >
            Privacy Policy
          </a>
          <span className="text-white">|</span>
          <a target="_blank" href="https://www.averitaspharma.com/terms-of-use/"
            className="text-white nav-link p-2" rel="noreferrer">
            Legal Disclaimer
          </a>
        </div>
      </div>

      <div className="accordion prescribing-accordion" id="accordionExample">
        <div className="accordion-item">
          <h2 className="accordion-header">
            <button onClick={changeAccordianVisibility} className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne">
              Please see important safety information and full prescribing information
              {isAccordianShown ? (
                <i className="bi bi-chevron-down ps-1"></i>
              ) : (
                <i className="bi bi-chevron-up ps-1"></i>
              )}
            </button>
          </h2>
          <div id="collapseOne" className="accordion-collapse collapse" data-bs-parent="#accordionExample">
            <div className="accordion-body ps-2 pe-2 pt-0">
              <div className="dropdown-data mt-3 mt-lg-0">
                <h3>INDICATION</h3>
                QUTENZA® (capsaicin) 8% topical system is indicated in adults for the treatment of neuropathic pain associated with postherpetic neuralgia (PHN) or associated with diabetic peripheral neuropathy (DPN) of the feet.

                <h3>IMPORTANT SAFETY INFORMATION</h3>

                Do not dispense QUTENZA to patients for self‑administration or handling. Use only on dry, unbroken skin. Only physicians or healthcare professionals are to administer and handle QUTENZA, following the procedures in the label.

                <h3>Warnings and Precautions</h3>

                <ul>
                  <li><b>Severe Irritation:</b> Whether applied directly or transferred accidentally from other surfaces, capsaicin can cause severe irritation of eyes, mucous membranes, respiratory tract, and skin to the healthcare professional, patients, and others. Do not use near eyes or mucous membranes, including face and scalp. Take protective measures, including wearing nitrile gloves and not touching items or surfaces that the patient may also touch. Flush irritated mucous membranes or eyes with water and provide supportive medical care for shortness of breath. Remove affected individuals from the vicinity of QUTENZA. Do not re‑expose affected individuals to QUTENZA if respiratory irritation worsens or does not resolve. If skin not intended to be treated comes into contact with QUTENZA, apply Cleansing Gel and then wipe off with dry gauze. Thoroughly clean all areas and items exposed to QUTENZA and dispose of properly. Because aerosolization of capsaicin can occur with rapid removal, administer QUTENZA in a well‑ventilated area, and remove gently and slowly, rolling the adhesive side inward.</li>

                  <li><b>Application-Associated Pain:</b> Patients may experience substantial procedural pain and burning upon application and following removal of QUTENZA. Prepare to treat acute pain during and following application with local cooling and/or appropriate analgesic medication.</li>

                  <li><b>Increase in Blood Pressure:</b> Transient increases in blood pressure may occur with QUTENZA treatment. Monitor blood pressure during and following treatment procedure and provide support for treatment‑related pain. Patients with unstable or poorly controlled hypertension, or a recent history of cardiovascular or cerebrovascular events, may be at an increased risk of adverse cardiovascular effects. Consider these factors prior to initiating QUTENZA treatment.</li>

                  <li><b>Sensory Function:</b> Reductions in sensory function (generally minor and temporary) have been reported following administration of QUTENZA. Assess for signs of sensory deterioration or loss prior to each application of QUTENZA. If sensory loss occurs, treatment should be reconsidered.</li>

                  <li><b>Severe Application Site Burns:</b> Full-thickness (third-degree) and deep partial-thickness (second-degree) burns have been reported following administration of QUTENZA. Cases of full-thickness (third-degree) burns, requiring hospitalization and skin grafting have been reported in patients who received QUTENZA for an unapproved indication and/or frequency of dosing at an application site where there had been prior skin trauma. Ensure that dosage and administration recommendations are followed.</li>
                </ul>

                <h3>Adverse Reactions</h3>
                The most common adverse reactions (≥5% and &gt; control group) in all controlled clinical trials are application site erythema, application site pain, and application site pruritus.

                <p>To report SUSPECTED ADVERSE REACTIONS, contact Averitas Pharma, Inc. at 1‑877‑900‑6479 or FDA at 1‑800‑FDA‑1088 or <a href="https://www.fda.gov/safety/medwatch-fda-safety-information-and-adverse-event-reporting-program">www.fda.gov/medwatch</a>.</p>

                <p>Please see full <a href="https://qutenzahcp.com/pdfs/qutenza_prescribing_information.pdf">Prescribing Information</a></p>
              </div>
            </div>

          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
